import PropTypes from 'prop-types';
import React from 'react';
import findKey from 'lodash/findKey';
import {
  USER_TYPES,
  getUserTypeLabel,
} from '../../../../auth/constants';

const userType = ({ user }) => (
  <div>
    <span display-if={user.brandId}>{getUserTypeLabel(USER_TYPES.brand)}</span>
    <span display-if={!user.brandId}>{getUserTypeLabel(user.kind)}</span>
  </div>
);

userType.propTypes = {
  user: PropTypes.object,
};

userType.defaultProps = {
  user: {},
};

export default userType;
